module.exports = __webpack_public_path__ + "b8eed0da0b35d1a3ab1755480a070b19.jpg";